import { useState } from "react";
import ChartFilterBar from "@/components/patient/ChartFilterBar";
import EncounterTable from "@/components/patient/EncounterTable";
import { PAT } from "@/constants/testIds";
import {
  EMPTY_ENCOUNTER_FILTERS,
  ENCOUNTER_FILTER_LABELS,
  filterEncounterRows,
} from "@/lib/patientChartClinical";

export default function EncountersWorkspace({ encounters = [], onSelect }) {
  const [filters, setFilters] = useState(EMPTY_ENCOUNTER_FILTERS);
  const rows = filterEncounterRows(encounters, filters.search);

  return (
    <section
      data-testid={PAT.chartEncountersPanel}
      className="emr-chart-dense rounded-xl border border-slate-200 bg-[#FFFFFF] p-4 shadow-[0_1px_2px_rgba(15,23,42,0.04)]"
    >
      <div className="mb-3 flex items-center justify-between gap-3">
        <h2 className="font-semibold text-slate-900">Encounters</h2>
      </div>
      <ChartFilterBar
        testId={PAT.chartEncountersFilters}
        labels={ENCOUNTER_FILTER_LABELS}
        searchValue={filters.search}
        onSearchChange={(search) => setFilters((current) => ({ ...current, search }))}
        searchTestId={PAT.chartEncountersSearch}
      />
      <EncounterTable encounters={rows} onSelect={onSelect} />
    </section>
  );
}
